export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fba9d8756ca8f0433ef560850eaa7b1358738d594&name=fetchTypeahead!'